import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  JobseekerInfoSkillViewModel,
  JobseekerModerationAttributeEnum,
  JobseekerSkillChanges,
  RejectModel,
  SkillItem,
} from '../../shared/models/jobseeker-moderation.model';

@Component({
  selector: 'app-jobseeker-moderation-skills',
  templateUrl: './jobseeker-moderation-skills.component.html',
  styleUrls: ['./jobseeker-moderation-skills.component.less'],
  standalone: false,
})
export class JobseekerModerationSkillsComponent {
  @Input() hardSkills: SkillItem[];
  @Input() softSkills: SkillItem[];
  @Input() isCreate: boolean;
  @Input() isEdited: boolean;
  @Input() changes: any;
  @Output() setDictionary: EventEmitter<RejectModel> =
    new EventEmitter<RejectModel>();
  public jobseekerEnum: any;

  constructor() {
    this.jobseekerEnum = JobseekerModerationAttributeEnum;
  }

  get hardSkillChanges(): JobseekerSkillChanges {
    return this.changes?.jobseekerHardSkillChanges;
  }

  get softSkillChanges(): JobseekerSkillChanges {
    return this.changes?.jobseekerSoftSkillChanges;
  }

  get removedHardSkills(): JobseekerInfoSkillViewModel[] {
    return this.hardSkillChanges?.removedSkillViewModels ?? [];
  }

  get removedSoftSkills(): JobseekerInfoSkillViewModel[] {
    return this.softSkillChanges?.removedSkillViewModels ?? [];
  }

  get showHardSkillsPlaceholder(): boolean {
    return (
      !this.hardSkills?.length &&
      !(this.isEdited && this.removedHardSkills.length)
    );
  }

  get showSoftSkillsPlaceholder(): boolean {
    return (
      !this.softSkills?.length &&
      !(this.isEdited && this.removedSoftSkills.length)
    );
  }

  get hasHardSkillChanges(): boolean {
    return this.hasChanges(this.hardSkillChanges)
  }

  get hasSoftSkillChanges(): boolean {
    return this.hasChanges(this.softSkillChanges);
  }

  rejectHardSkills(event) {

    this.setDictionary.emit({
        key: this.jobseekerEnum.HardSkill,
        value: event.value,
    });
  }

  rejectSoftSkills(event) {

     this.setDictionary.emit({
        key: this.jobseekerEnum.SoftSkill,
        value: event.value,
      });
  }

  

  isAdded(
    skill: SkillItem,
    skillChanges: JobseekerSkillChanges
  ): boolean {
    return skillChanges?.addedSkills?.some((val) => val.index === skill.index)    
  }

  isCustom(skill: SkillItem): boolean {
    return skill.canonicalSkillId === null;
  }

  isRemovedCustom(skill: JobseekerInfoSkillViewModel): boolean {
    return !skill.skillId;
  }

  skillName(skill: SkillItem): string {
    return !this.isCustom(skill) && skill.name
      ? skill.name
      : skill.userProvidedText;
  }

  removedSkillName(skill: JobseekerInfoSkillViewModel): string {
    return !this.isRemovedCustom(skill) && skill.name
      ? skill.name
      : skill.userProvidedText;
  }

  private hasChanges(skillChanges: JobseekerSkillChanges): boolean {
    return (
      skillChanges?.addedSkills?.length > 0 ||
      skillChanges?.changedSkills?.length > 0 ||
      skillChanges?.removedSkills?.length > 0
    );
  }
}
